import { render } from "./CardContent.vue?vue&type=template&id=0d0cc8c3&scoped=true"
import script from "./CardContent.vue?vue&type=script&lang=js"
export * from "./CardContent.vue?vue&type=script&lang=js"

import "./CardContent.vue?vue&type=style&index=0&id=0d0cc8c3&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0cc8c3"]])

export default __exports__